import * as React from "react";
import { Ref, SVGProps, forwardRef } from "react";
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    ref={ref}
    {...props}
  >
    <path
      fill="orange"
      d="M12.761 1.163c1.356.059 2.453.654 3.44 1.418 1.192.923 2.237 2.03 3.3 3.092 1.183 1.182 2.202 2.201 2.917 3.125.765.988 1.36 2.085 1.42 3.44a5.99 5.99 0 0 1 0 .523c-.06 1.356-.655 2.453-1.42 3.44-.715.925-1.734 1.944-2.917 3.126-1.063 1.063-2.108 2.169-3.3 3.091-.987.765-2.084 1.36-3.44 1.42a5.99 5.99 0 0 1-.522 0c-1.356-.06-2.453-.655-3.44-1.42-.925-.715-1.944-1.734-3.126-2.917-1.063-1.063-2.169-2.108-3.092-3.3-.764-.987-1.36-2.084-1.418-3.44a6.01 6.01 0 0 1 0-.522c.059-1.356.654-2.453 1.418-3.44.923-1.192 2.03-2.238 3.092-3.3C6.855 4.315 7.874 3.296 8.798 2.58c.988-.764 2.085-1.36 3.44-1.418.175-.008.35-.008.523 0ZM12.5 14.499a2 2 0 1 0 .001 4.002 2 2 0 0 0-.002-4.002Zm0-8a2 2 0 0 0-2 2v3a2 2 0 0 0 4 0v-3a2 2 0 0 0-2-2Z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
